import React, { Component } from 'react';
import { connect } from 'react-redux';
import SelfieForm from './SelfieForm';
import {
  isRenaultFranceUserSelector,
  messagesSelector,
  selfieFormInitialValuesSelector,
  userCompanyIdSelector,
  userDataSelector,
  userIdSelector
} from '../../helpers/selectors';

import { FILE_STATUS_SELFIE } from '../../constants/backend';

import {
  addToIndex,
  getFileIdFromField,
  setSelfieFile,
  createGetFileTypeFinder
} from '../../utils/utils';

import _findIndex from 'lodash/findIndex';
import { cleanUserDataForApi } from '../../helpers';
import { bindActionCreators } from 'redux';
import * as UserActions from '../../actions/user';
import { displayProfileUpdateSuccess } from '../../helpers/components';

class Selfie extends Component {
  constructor(props) {
    super(props);
    this.bindFunctions();
  }

  bindFunctions() {
    this.updateSelfieDocument = this.updateSelfieDocument.bind(this);
  }

  formatDataForApiCall(userData = {}, formValues = {}) {
    const { selfieImage } = formValues;
    const { identityDocument } = userData;
    const { files } = identityDocument || {};
    const newFiles = files ? [...files] : [];

    const findSelfie = createGetFileTypeFinder(FILE_STATUS_SELFIE);
    const selfieFile = setSelfieFile(getFileIdFromField(selfieImage));
    const selfieFileIndex = _findIndex(newFiles, findSelfie);

    addToIndex(newFiles, selfieFileIndex, selfieFile);

    const newData = { ...userData, identityDocument: { files: newFiles } };
    return cleanUserDataForApi(newData);
  }

  updateSelfieDocument(formValues) {
    const {
      m,
      updateInformations,
      userId,
      userData,
      updateInformationsFetching
    } = this.props;

    if (!updateInformationsFetching) {
      updateInformations(userId, this.formatDataForApiCall(userData, formValues)).then(
        (data) => {
          if (data.type === 'user/UPDATE_INFORMATIONS_SUCCESS') {
            displayProfileUpdateSuccess(m, 'profile.section.selfie');
          }
        }
      );
    }
  }

  render() {
    const { initialValues, isRenaultFranceUser } = this.props;

    return (
      <SelfieForm
        onSubmit={this.updateSelfieDocument}
        initialValues={initialValues}
        hideFileUpload={isRenaultFranceUser}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const { updateInformationsFetching } = state.user;

  return {
    userId: userIdSelector(state),
    userData: userDataSelector(state),
    m: messagesSelector(state),
    isRenaultFranceUser: isRenaultFranceUserSelector(state),
    userCompanyId: userCompanyIdSelector(state),
    initialValues: selfieFormInitialValuesSelector(state),
    updateInformationsFetching
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...UserActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Selfie);
